<template>
  <div class="d-flex flex-column">
    <div class="subcategory d-flex flex-column justify-space-around align-center py-5">
      <SubcategoryButton
        icon="cloud_queue"
        text="Problem with CO2"
      />
      <SubcategoryButton
        icon="grain"
        text="Problem with Humidity"
      />
      <SubcategoryButton
        icon="thermostat"
        text="Problem with Temperature"
      />
      <SubcategoryButton
        icon="more_horiz"
        text="Other"
      />
    </div>
  </div>
</template>

<script>
import SubcategoryButton from '@/components/repairTickets/SubcategorySelection/SubcategoryButton.vue';

export default {
  name: 'IrrigationSubcategorySelection',
  components: {
    SubcategoryButton,
  },
  methods: {},
};
</script>

<style lang="scss"></style>
